import { render, staticRenderFns } from "./MessageReports.vue?vue&type=template&id=8627c64e&scoped=true&"
import script from "./MessageReports.vue?vue&type=script&lang=js&"
export * from "./MessageReports.vue?vue&type=script&lang=js&"
import style0 from "./MessageReports.vue?vue&type=style&index=0&id=8627c64e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8627c64e",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QBtn,QTooltip,QChip,QInput,QIcon,QTd,QTh,QPagination,QDialog});
